import { HrObjectType } from './HrObjectType';

export const HrObjectTypeNameFormat = {
	[HrObjectType.Users]: {
		format: '{code} ({name})',
		properties: ['code', 'name']
	},
	[HrObjectType.Positions]: {
		format: '{code} ({name})',
		properties: ['code', 'name']
	},
	[HrObjectType.Department]: {
		format: '{code} ({name})',
		properties: ['code', 'name']
	},
	[HrObjectType.Professions]: {
		format: '{code} ({name})',
		properties: ['code', 'name']
	},
	[HrObjectType.Groups]: {
		format: '{code} ({name})',
		properties: ['code', 'name']
	},
	[HrObjectType.PropertyTypes]: {
		format: '{code} ({name})',
		properties: ['code', 'name']
	},
	[HrObjectType.ManagerKeys]: {
		format: '{description}',
		properties: ['description']
	}
};
